@if (user$ | async; as user) {
    <mat-toolbar class="flex align-space-around">
        <button mat-icon-button (click)="editPreferences()">
            <mat-icon>settings</mat-icon>
        </button>
        <button mat-icon-button>
            <mat-icon>help</mat-icon>
        </button>
        <button mat-icon-button (click)="logout()">
            <mat-icon>logout</mat-icon>
        </button>
    </mat-toolbar>
}
